<template>
    <el-drawer
        :before-close="cancel"
        :title="`${type === 1 ? '沟通' : '专项汇报'}  ${tipAdd()}`"
        :visible.sync="dialogVisible"
        :wrapperClosable="true"
        append-to-body
        :z-index="2"
        center
        class="dialog-container flex flex-direction"
        direction="rtl"
        size="700px">
        <div class="dialog-content flex flex-direction padding-lr-sm flex-sub">
            <div class="text-black text-df"><i class="iconfont icon-vertical_line text-black text-bold text-df"></i>{{ pname }}</div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form radius margin-top-sm padding" labelWidth="auto">
                <el-form-item label="时间" prop="r_time">
                    <el-date-picker v-model="ruleForm.r_time"
                                    format="yyyy 年 MM 月 dd 日"
                                    placeholder="请选择"
                                    type="date" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                   <ck-basic-editor :content="content" @watchEditor="watchEditor"></ck-basic-editor>
                </el-form-item>
                <el-form-item class="document" label="材料" prop="file">
                    <div class="flex margin-bottom-sm">
                        <div class="flex-sub flex flex-direction">
                            <div v-for="(item,index) in ruleForm.file" :key="index" class="flex align-center justify-between">
                                <div :href="item.url" class="file-name flex-sub ovHide text-sm" target="_blank" @click="toFilePreview(item.name,item.url)">
                                    <i class="el-icon-tickets margin-right-xs"></i>{{ item.name }}
                                </div>
                                <el-button class="el-icon-delete text-orange" type="text" @click="delFile(item,index)"></el-button>
                            </div>
<!--                            <el-upload-->
<!--                                :action="FILE_UPLOAD_HOST"-->
<!--                                :before-upload="beforeAvatarUpload"-->
<!--                                :data="QNData"-->
<!--                                :on-error="uploadError"-->
<!--                                :on-success="uploadSuccess"-->
<!--                                :show-file-list="false">-->
<!--                                <div class="flex align-start">-->
<!--                                    <el-button class="btn small radius" size="small" type="primary">上传附件</el-button>-->
<!--                                </div>-->
<!--                            </el-upload>-->
                            <upload-file class="flex align-start" @uploadFile="uploadFile">
                                <el-button slot="upload" class="btn small radius" size="small" type="primary">上传附件</el-button>
                            </upload-file>
                        </div>

                    </div>
                </el-form-item>
            </el-form>
            <div class="foot-view"></div>
            <div class="foot flex align-center justify-around margin-top">
                <el-button class="btn max radius" plain @click="cancel">取消</el-button>
                <el-button :loading="loading" class="btn max radius" type="primary" @click="submitForm('ruleForm')">保存
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import {addProjectReport} from "@/api";
import {confirm, tipAdd, TOAST, toast, toFilePreview} from "@/utils/utils";
import CkBasicEditor from "@/views/web/components/CKBasicEditor";
import UploadFile from "@/views/web/components/UploadFile";
export default {
    name: "ReportNodeDialog",
    components: {UploadFile, CkBasicEditor},
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        nid: { //节点ID
            type: Number,
        },
        pid: { //项目ID
            type: Number,
        },
        pname: { //项目ID
            type: String,
        },
        info: { //
            type: Object,
        },
    },
    data() {
        return {
            content:'',
            ruleForm: {
                r_time: '',
                content: '',
                file: [],
            },
            rules: {
                r_time: [
                    {required: true, message: '请选择时间', trigger: 'change'},
                ]
            },
            type:0,
            loading:false
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            if (this.info) {
                this.type = this.info.type
                this.ruleForm = {
                    r_time: this.info.r_time,
                    content:this.info.content,
                    file:  this.info.file,
                }
                this.content = this.info.content
            } else {
                this.type = 2
                this.content = ''
                this.ruleForm = {
                    r_time: '',
                    content: '',
                    file: [],
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addItem();
                }
            });
        },
        async addItem() {
            this.loading = true
            let _data = await addProjectReport(this.pid, this.nid, this.ruleForm.r_time, this.ruleForm.content,
                JSON.stringify(this.ruleForm.file))
            this.loading = false
            if (_data.status === 200) {
                toast(`${tipAdd()}成功`, TOAST.success)
                this.$emit('watchState', true)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        cancel(){
            this.$emit('watchState', false)
        },
        tipAdd() {
            return tipAdd(this.nid, '添加')
        },
        delFile(item,index) {
            confirm(`删除文件`, `你确定删除<b>${item.name}</b>文件吗？`, () => {
                this.ruleForm.file.splice(index,1)
            }, '确认', true)
        },
        //  上传成功
        uploadFile(data) {
            this.ruleForm.file.push({
                name: data.file.name,
                url: data.file.url
            })
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        },
        watchEditor(data) {
            this.ruleForm.content = data
        }
    },
    filters: {},
    watch: {
        info() {
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-container {
    .publish-form{
        border: solid 1px #e6e6e6;
    }
}

</style>